module.exports = __webpack_public_path__ + "img/m19.2cf4b80.jpg";